(function() {
	'use strict';

	angular
		.module('as.groups')
		.controller('networkViewCtrl',networkViewCtrl);

	networkViewCtrl.$inject = ['$scope','$rootScope','filterData','$http','asMessages','profileFilling','$state','$timeout','$interval','$stateParams','$filter'];
	function networkViewCtrl($scope,$rootScope,filterData,$http,asMessages,profileFilling,$state,$timeout,$interval,$stateParams,$filter) {
		//var 
		$scope.userList = [];
	
		$scope.members_stream = 1;
		$scope.fetching = false;
		$scope.filterData=[];
		$scope.info = {is_new_member: false, showCongrastMsg:false, showQuestion:false};
		if($stateParams.cbt=="congrats")
			$scope.info.showCongrastMsg=true;
		//functions
		$scope.sendMessage = sendMessage;
		$scope.workDataFilling=workDataFilling;
		$scope.becomeNetworkMember=becomeNetworkMember;
		$scope.updateWork=updateWork;
		$scope.removeFromNetwork=removeFromNetwork;
		$scope.markUserPref=markUserPref;
		$scope.getUsers=getUsers;

		activate();
		function activate() {
			if(!$rootScope.featureEnabled('alumni_value_networks')) {
				snackbar_general($filter('asPortalLang')('Unknown_Error',"Something went wrong"),3000);
				$state.go('inapp.404');
			}

			if(!filterData || !filterData.data || filterData.data.success!=1){
				snackbar_general($filter('asPortalLang')('Unknown_Error',"Something went wrong"),3000);
				$state.go('inapp.networks');
			}

			$scope.filterData=filterData.data.data;
			$scope.userName={'shortName':$rootScope.app_data.data.short_name,'firstName': $scope.filterData.name};
	     	$scope.shortName={'shortName': $rootScope.app_data.data.short_name}
		    $scope.dataName={'dataName':$scope.filterData.name}
			$scope.recognizedName=$filter('asPortalLang')('Recognized_Name',"Get Recognized as [DATA:shortName] [DATA:firstName]",$scope.userName);
		    $scope.registerAlumniPlat=$filter('asPortalLang')('Register_Alumni_Plat',"Register on [DATA:shortName] Alumni Platform",$scope.shortName)
			getUserPref();
			$scope.messageSourceAndContext={"source" : "Networks","context" : $scope.filterData.id};
		}

		function getUserPref() {
			$http.post('./filters/dyn_filters_ctrl/getUserPref',{fid:$scope.filterData.id})
			.then(function(res) {
				if(res && res.data && res.data.data && res.data.success && res.data.success == 1 ) {
					$scope.userPref=res.data.data;
					if($scope.userPref && $scope.userPref['pref']==0) 
						$scope.info.showQuestion=true;
				}else if(res && res.data && res.data.success == 0) {
					$scope.info.showQuestion=true;
				}
				as_upgrade(100);
			});
		}

		function getUsers(){
			if(!angular.isDefined($scope.filterData.id) && !$scope.filterData.id)return;
			if($scope.fetching || $scope.members_stream <= 0) return;
			var data={fid:$scope.filterData.id,stream:$scope.members_stream,limit:20};
			$scope.fetching = true;
			$http.post('./filters/dyn_filters_ctrl/getUserList',data)
			.then(function(res) {
				if(res && res.data && res.data.data && res.data.data[$scope.filterData.id] &&res.data.data[$scope.filterData.id]['users'] && res.data.success == 1 ) {
					$scope.userList=$scope.userList.concat(res.data.data[$scope.filterData.id]['users']);
					$scope.members_stream++;
				}else if(res && res.data && res.data.success == 0) {
					$scope.members_stream = -1;
				}
				$scope.fetching = false;
				as_upgrade(100);
			});
		}


		function sendMessage(user,event) {
			var user = {
			  name: user.First_Name+" "+user.Last_Name,
			  uui: user.uui,
			  uid: user.uid,
			  is_authenticated: user.is_authenticated
			};

			var params = {
			  heading: $filter('asPortalLang')('Profile_Send_Msg',"Send Message"),
			  hideChips: true,
			  defaultMessage: $filter('asPortalLang')('Name_Found_Msg',"Hi, I found your name under [DATA:name] on [TERM:Alumni_Portal:lowercase] and would like to connect to you.",{'name':$scope.filterData.name}),
			  messageSourceAndContextNeeded : $scope.messageSourceAndContext
			};
			asMessages.openSendBox(user, event.target, function() {}, params);
		}

		function becomeNetworkMember(){//Question Yes btn action
		 	profileFilling.modal('work',function () {
		  		 markUserPref('add');
            },false,{forcedFlow:true,title:$filter('asPortalLang')('Update_Work_Detail',"Update Work Details")} );
		}
 	
		function workDataFilling(){//Question No btn action
			$scope.info.showQuestion=false;
			profileFilling.modal('work',function () {
            },false,{title:$filter('asPortalLang')('Update_Work_Detail',"Update Work Details")} );
 		}

		function updateWork(){//update work btn action
			profileFilling.modal('work',function () {
				snackbar_general($filter('asPortalLang')('Work_Updated_Msg',"Work updated successfully"),3000);
            },false,{forcedFlow:true} );
 		}

		function removeFromNetwork(index){//I am not in this network btn action
			profileFilling.modal('work',function () {
				markUserPref('remove',index);
            },false,{forcedFlow:true,title:$filter('asPortalLang')('Update_Work_Detail',"Update Work Details")} );
 		}

		function markUserPref(action,index){//action='remove' or 'add'
			var data={fid:$scope.filterData.id};
			if(action=='remove'){data.pref=0;}
			if(action=='add'){data.pref=1;}
			$http.post('./filters/dyn_filters_ctrl/mark_user_pref',data)
			.then(function(res) {
				if(res && res.data && res.data.success == 1 ) {
					if(data.pref==1){
						snackbar_general($filter('asPortalLang')('Preference_Update_Msg',"Preference updated successfully"),3000);
						$scope.info.showCongrastMsg=true;
						$scope.info.showQuestion=false;
						$state.go('inapp.single_network', {fid:$scope.filterData.id,cbt:"congrats"});
					}else{
						if(angular.isDefined($scope.userList[index]))
							$scope.userList.splice(index, 1);
						$scope.info.showQuestion=true;
						$scope.filterData.count--;
						snackbar_general($filter('asPortalLang')('Preference_Update_Msg',"Preference updated successfully"),3000);
					}
				}else{
					snackbar_general($filter('asPortalLang')('Update_Failed_Msg',"Updation failed. Try again later."),3000);
				}
			});
		}
	}
})();